const isInBO = () => window.location.pathname.startsWith('/backoffice/');

export default isInBO;
